export default function () {
  return {
    form: {
      sections: [],
    },
    applyResponse: {},
    activeQuote: null,
    cardPaymentStatus: null,
    questionMap: {},
    paymentErrorMessage: "",
  };
}
